var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "signIn" } }, [
    _c(
      "section",
      [
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.showActivityIndicator
            ? _c("div", { staticClass: "loading" }, [
                _c("p", [_vm._v("Signing in...")])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.errorMessage.length > 0
            ? _c("div", { staticClass: "errorMessage" }, [
                _c("div", [
                  _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          _vm.errorMessage = ""
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.showPhoneNumberInput
          ? [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("p", [_vm._v("Country code")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phoneNumberInputForm.country,
                        expression: "phoneNumberInputForm.country"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Country code (+1 for USA)",
                      required: ""
                    },
                    domProps: { value: _vm.phoneNumberInputForm.country },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.phoneNumberInputForm,
                          "country",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("Phone number")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phoneNumberInputForm.number,
                        expression: "phoneNumberInputForm.number"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Phone number",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.phoneNumberInputForm.number },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.phoneNumberInputForm,
                          "number",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "submit",
                        id: "get-sign-in-code",
                        disabled: this.disableUI
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(this.disableUI ? "Initializing..." : "Sign In")
                      )
                    ]
                  )
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.showVerificationCodeInput
          ? [
              _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("p", [_vm._v("Verification code")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.verificationCodeInputForm.code,
                        expression: "verificationCodeInputForm.code"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "Verification Code",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.verificationCodeInputForm.code },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.verificationCodeInputForm,
                          "code",
                          $event.target.value
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { type: "submit", disabled: this.disableUI },
                      on: {
                        click: function($event) {
                          return _vm.verifySignInWithCode()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(this.disableUI ? "Initializing..." : "Verify")
                      )
                    ]
                  )
                ]
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb473e1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb473e1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignIn.vue
// module id = null
// module chunks = 